import { mount } from 'svelte';
import App from './App.svelte';
import { initLocale } from './lib/i18n.js';
import './app.css';

const target = document.getElementById('app');
if (!target) throw new Error('Missing #app');

initLocale();
mount(App, { target });
